import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

import { MetaCampaignStatus } from '../campaignList-process/api-actions'
import { AdCampaignCountriesTierEnum } from '../../Pages/Artist/AdsSchedulePage/AdsScheduleSettingsPage/components/AdsCountriesModal/helpers'

export enum AdCampaignStrategyEnum {
  PLAYLIST = 'playlist',
  TRACK = 'track',
}

export enum AdCampaignVisualTypeEnum {
  AI = 'ai_powered',
  MANUAL = 'manual',
}

export enum AdCampaignPlacementsTypeEnum {
  Instagram = 'Instagram',
  Facebook = 'Facebook',
}

export type CreateAdCampaignBody = {
  countries?: string[]
  countriesTier?: AdCampaignCountriesTierEnum
  coverUrl: string
  dailyBudget?: number
  daysCount?: number
  genres?: string[]
  ownerName: string
  ownerSpotifyUrl: string
  resourceName: string
  resourceSpotifyId: string
  resourceSpotifyUrl: string
  similarArtistNames?: string[]
  strategy: AdCampaignStrategyEnum
  visualType?: AdCampaignVisualTypeEnum
}

export type AdVisualDescriptionQuestion = {
  question: string
  answer: string
}

export type CreateAdCampaignResponse = {
  id: number
  countries: string[]
  countriesTier: AdCampaignCountriesTierEnum
  coverUrl: string
  createdAt: string
  dailyBudget: number
  daysCount: number | null
  endDate: string
  genres: string[]
  languages: string[]
  landingKey: string
  ownerName: string
  ownerSpotifyUrl: string
  paymentId: string
  resourceName: string
  resourceSpotifyId: string
  resourceSpotifyUrl: string
  similarArtistNames: string[]
  startDate: string
  status: string
  strategy: AdCampaignStrategyEnum
  totalBudget: number
  updatedAt: string
  userId: number
  visualType?: AdCampaignVisualTypeEnum
  adVisualDescription: AdVisualDescriptionQuestion[] | null
  shouldAutoRenew: boolean
}

export interface MetaCampaign {
  id: number
  createdAt: string
  endDate: string
  startDate: string
  platformType: CampaignPlatformTypeEnum.META
  status: MetaCampaignStatus
  trackAuthorName: string
  trackTitle: string
  trackCoverUrl: string
  relaunched: never
  reviewedReviews: never
  allReview: never
  submittedVideosAmount: number
}

const adCampaignApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    createAdCampaign: build.mutation<
      CreateAdCampaignResponse,
      CreateAdCampaignBody
    >({
      query: (newCampaign) => ({
        url: `${APP.TIKTOK_SERVER}/artist/ad-campaigns`,
        method: 'POST',
        body: newCampaign,
      }),
    }),
  }),
})

export const { useCreateAdCampaignMutation } = adCampaignApi
